import currencyFormatter from 'currency-formatter';
export default num =>
  currencyFormatter.format(num / 100, {
    code: 'ZAR',
    decimal: '.',
    thousand: ','
  });
